<template>
  <div class="LC_procedure2" ref="LC_procedure2">
    <div class="viewBox">
      <ul class="procedure-box">
        <li
          class="procedure-row"
          v-for="(item, i) in dataList"
          :idx="i"
          :key="i"
          @click="rowClick(i)"
        >
          <div class="procedure-name">{{ item.process }}</div>
          <div class="procedure-status-box">
            <div class="leftBox">
              <div class="box1">同比</div>
              <div class="box2" :class="{up:upOrDown(item.percentage,'up'),down:upOrDown(item.percentage,'down')}">{{ !is89 ? item.percentage + '%' : '----' }}</div>
              <div class="box2i" v-if="!is89" :class="{box2iup:upOrDown(item.percentage,'up'),box2idown:upOrDown(item.percentage,'down')}"></div>
            </div>
            <div class="rightBox">
              <!-- <div id="animateNum" class="box3 number" :style="{color:getColor(i)}">{{item.total}}</div> -->
              <div class="box3 number" :style="{ color: getColor(i) }">
                <!-- <span :id="'animateNum'+i">0</span> -->
                <span>{{ item.total.toFixed(2) }}</span>
                <!--                <number-scroll-component
                  :totalData="Number(item.total.toFixed(2))"
                  :symbolIndex="i"
                  :color="getColor(i)"
                />-->
              </div>
              <div class="unit">吨</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import carbonEmission from "@/modules/lowcarbonComponents/carbonDischargeInfo/carbonEmissionProcess";
import { numAutoPlusAnimation } from "@/utils/tools.js";
import NumberScrollComponent from "./numberScrollComponent_.vue";
import countUp from "@/js/count-up.js";
// import carbonEmission from '@/modules/lowcarbonComponents/carbonDischargeInfo/carbonEmission';
import { mapGetters } from "vuex";
export default {
  components: {
    carbonEmission,
    NumberScrollComponent,
  },
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'LC_procedure.vue',
      computedName: '工序碳排放组件',
      customerId: this.$store.state.customerId,
      dataList: [],
      setTime1: null,
      timer: null,
      is89: false,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getColor() {
      return (i) => {
        let colorVal;
        if (i == 0) {
          colorVal = "#ff7373";
        } else if (i == 1) {
          colorVal = "#f4c48f";
        } else if (i == 2) {
          colorVal = "#ffff89";
        } else {
          colorVal = "#99f5ff";
        }
        return colorVal;
      };
    },
    upOrDown() {
      return (val, type) => {
        if (type == "down") {
          if (val < 0) {
            return true;
          }
        } else if (type == "up") {
          if (val >= 0) {
            return true;
          }
        }
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  //监控data中的数据变化
  watch: {
    dataList: {
      handler(res) {
        if (res && res.length) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.$nextTick(() => this.getNumIncrease(res));
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.customerId == 89) {
      this.is89 = true
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.LC_procedure2).outerWidth();
    let h = $(that.$refs.LC_procedure2).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    rowClick(i) {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(carbonEmission, this.dialogCompontent, {
        pageTitleName: "工序碳排放",
      });
    },
    autoMove() {
      let that = this;
      $(".viewBox .procedure-box").each(function () {
        const dom = $(this).children();
        // $(this).empty();
        var rows = dom.clone(true);
        rows.addClass("copy");
        $(this).append(rows);
        for (let i = 0; i < rows.length; i++) {
          let tmpRow = $(rows.get(i));
          tmpRow.unbind("click");
          tmpRow.bind("click", function () {
            that.rowClick($(this).attr("idx"));
          });
        }
      });
    },
    async getListData() {
      let that = this;
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getProcedureTypeData =
          CONFIG.requestName + this.$apiOpt.getProcedureTypeData;
        let res = await this.$apiUtils.get(getProcedureTypeData, {
          customerId: this.customerId,
        });
        $(".procedure-box").removeClass("animate");
        this.dataList = [];
        $(".copy").remove();
        this.$forceUpdate();
        this.$nextTick(() => {
          this.dataList = res || [];
          this.$forceUpdate();
          if (res && res.length >= 8) {
            that.$nextTick(() => {
              // that.autoMove();
              // $('.procedure-box').addClass('animate');
            });
          }
        });
        //$(".viewBox .procedure-box").empty();
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 1000 * 3);
    },

    // 动画函数
    getNumIncrease(data) {
      const options = {
        useEasing: true, // 过渡动画效果，默认ture
        useGrouping: true, // 千分位效果，例：1000->1,000。默认true
        separator: "", // 使用千分位时分割符号
        decimal: ".", // 小数位分割符号
        prefix: "", // 前置符号
        suffix: "", // 后置符号，可汉字
      };
      if (Array.isArray(data) && data.length) {
        data.forEach((d, i) => {
          // numAutoPlusAnimation(document.getElementById(`animateNum${i}`), {
          //   time: 1500,
          //   num: d.total,
          //   regulator: 10,
          // });
          new countUp(
            document.getElementById(`animateNum${i}`),
            0,
            d.total,
            2,
            3,
            options
          ).start();
        });
      }
      this.timer = setTimeout(() => this.getNumIncrease(data), 1000 * 10);
    },
  },
};
</script>
<style lang="scss" scoped>
.LC_procedure2 {
  height: 520px;
  width: 600px;
  pointer-events: all;
  padding-top: 62px !important;
  .viewBox {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
    @keyframes move {
      0% {
      }
      100% {
        transform: translateY(-50%);
      }
    }
    .procedure-box {
      .procedure-row {
        width: 560px;
        height: 67px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(img/commonRow.png);
        background-size: 300% 100%;
        margin-bottom: 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 10px;
        &:hover {
          @extend .active;
        }
        .procedure-name {
          font-size: 18px;
          color: #99c0ff;
          line-height: 67px;
          text-overflow: ellipsis;
          width: 28%;
          overflow: hidden;
          white-space: nowrap;
          word-break: break-all;
        }
        .procedure-status-box {
          display: flex;
          width: 72%;
          justify-content: space-between;
          height: 100%;
          padding-bottom: 10px;
          padding-left: 10px;
          .leftBox {
            width: 120px;
            display: flex;
            align-items: flex-end;
            .box1 {
              font-size: 18px;
              color: #a0aaab;
              line-height: 18px;
              margin-right: 5px;
            }
            .box2 {
              font-size: 18px;
              color: #ec2323;
              line-height: 13px;
            }
            .box2i {
              margin-left: 2px;
              margin-bottom: -1px;
            }
            .box2iup {
              @include bg-box(12px, 20px, "upicon.png");
            }
            .box2idown {
              @include bg-box(12px, 20px, "downicon.png");
            }
            .up {
              color: #ec2323;
            }
            .down {
              color: #7ff4b1;
            }
          }
          .rightBox {
            width: calc(100% - 120px);
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            .box3 {
              width: calc(100% - 20px);
              font-size: 32px;
              color: #99f5ff;
              line-height: 38px;
            }
            .unit {
              width: 20px;
              height: 18px;
              font-size: 18px;
              color: #a0aaab;
              line-height: 18px;
              margin-left: 5px;
            }
          }
        }
      }
      .active {
        background-image: url(img/activeRow.png);
        background-size: 300% 100%;
      }
    }
    .animate {
      animation: move 30s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
  }
}
</style>
